import React, { FC, memo } from 'react'

import useStore from '@/store/useStore'

import { YouTubePlayer } from './YouTubePlayer'

const YoutubePlayerPopupRaw: FC = () => {
  const youTubeVideo = useStore((state) => state.common.youTubeVideo)

  return youTubeVideo && <YouTubePlayer youTubeContent={youTubeVideo} />
}

export const YoutubePlayerPopup = memo(YoutubePlayerPopupRaw)
